import { isTopQuestionnaireRequestCookie } from 'src/scripts/cookie'

import {
  adaptMessageImage,
  adaptResponse
} from 'src/scripts/adapter'

import { fromShopCampaign, fromEC } from 'src/scripts/urlquery'

import { TQuestion, TQuestionInput } from 'src/store/state'
import { Ajax } from 'src/uses/ajax/index'

import { addTalk, clearTalk } from 'src/modules/talk'
import { openModal } from 'src/modules/modal'
import { setResponse, setClientname } from 'src/modules/result'
import { setTalkStart, setShowRestart, setPrevResultStart, setQuestionnaireEnded } from 'src/modules/status'
import { addQuestion, clearAnswers } from 'src/modules/questions'

import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollToPlugin)

/*---
 * values
 */
export const TALK_DELAY:number = 500
export const TALK_CLASS_PREFIX:string = 'talk'

/*---
 * functions
 */
export const timeout = (ms:number): Promise<void> => {
  return new Promise<void>(resolve => setTimeout(resolve, ms))
}

export const getOffset = (elem) => {
  const pos = {
    x: 0,
    y: 0
  }

  while (elem) {
    pos.y += elem.offsetTop || 0
    pos.x += elem.offsetLeft || 0
    elem = elem.offsetParent
  }
  return pos
}

export const nl2br = (str) => {
  return str.replace(/\n/g, '<br>')
}

export const nl2Arr = (str) => {
  return str.split(/\n/g)
}

export const trimbr = (str) => {
  return str.replace(/\n/g, '')
}

// export const getStaticText = (text) => {
//   const TGT_WORDS = /<br \/>|<span>|<\/span>/g
//   const staticTxt = text.replace(TGT_WORDS, '')
//   return staticTxt
// }

export const getTalkClass = (talkID?:string, talkType?:string, iterator?:number) => {
  const nameArray = [`.${TALK_CLASS_PREFIX}`]
  talkID && nameArray.push(`_${talkID}`)
  talkType && nameArray.push(`-${talkType}`)
  iterator && nameArray.push(`-${iterator}`)
  return nameArray.join('')
}

export const scrollTargetTop = (selector:string, state) => {
  const elems = document?.querySelectorAll<HTMLElement>(`${selector}`)
  if (!elems.length) { return }

  const elem = elems[elems.length - 1]
  if (!elem) { return }

  const parentElem = <HTMLElement>document?.querySelector('#talk')
  if (!parentElem) { return }

  const offset = getOffset(elem)
  const parentOffset = getOffset(parentElem)
  const scrollY = offset && offset.y
  const diff = state.device.media === 'pc' ? parentOffset.y : 0

  const y = scrollY - diff
  if (y < 0) { return }

  gsap.to(window, {
    duration: 0.5,
    scrollTo: {
      y
    }
  })
}

export const scrollTargetBottom = (selector:string, state?) => {
  const elem = <HTMLElement>document?.querySelector(`${selector}`)
  const offset = getOffset(elem)
  const elemRect = elem?.getBoundingClientRect()
  const scrollY = offset && offset.y - (window.innerHeight - (elemRect?.height || 0))

  const parentElem = document.querySelector('#talk')
  const childElem = parentElem && parentElem.firstChild
  const diff = parentElem && childElem
    ? parentElem.clientHeight - (childElem as any).clientHeight
    : 0

  gsap.to(window, {
    duration: 0.5,
    scrollTo: {
      y: (scrollY + diff)
    }
  })
}

export const getStructureID = (id, state) => {
  let structureIterator = 0
  if (id === 'btn_result_action' || id === 'resultq') {
    const history = state.talk.history
    for (let i = 0; i < history.length; i++) {
      const historyFormId = history[i].id
      if (id === historyFormId) structureIterator++
    }
  }

  return structureIterator ? String(structureIterator) : ''
}

export const getResultID = (state) => {
  return state.result
    && state.result.storageKey
    && localStorage.getItem(state.result.storageKey)
}

export const getClientName = (state) => {
  const key = state.result
    && state.result.clientNameKey
    && localStorage.getItem(state.result.clientNameKey)
  if (!key || key.match(/^(undefined|null)$/i)) {
    return ''
  }
  return key
}

export const talkBegined = (dispatch) => {
  dispatch(setShowRestart(true))
}

/*---
 * common multi dispather
 */
export const talkMessage = async (response, state, dispatch) => {
  const id = `${response.id}_message_${(response.iterator - 0) + 1}`
  const image = adaptMessageImage(response.id)

  if (!response.data) {
    response.data = {}
  }

  await dispatch(addTalk({
    id,
    type: id,
    data: {
      id,
      image,
      text: response.text,
      ...response.data
    }
  }, TALK_DELAY))

  if ((response.iterator - 0) === 0) {
    scrollTargetTop(getTalkClass(id), state)
  }
}

export const talkPastRecommendProc = async (state, dispatch) => {
  const response:any = await dispatch(Ajax({
    name: 'pastrecommend'
  }))
  response.id = 'pastrecommend'
  response.form_id = 'pastrecommend'

  response.question_array = []
  response.question_type = ''
  dispatch(setResponse(response))
  const brand_array = response.brand_array

  // for (let i = 0; i < brand_array.length; i++) {
    ;(async () => {
      // const arr = brand_array[i]
      const arr = brand_array
      const o = Object.assign({}, response)
      const custom = 'pastrecommend'
      o.form_id = o.id = custom + 0
      o.brand_array = arr
      // let custom = 'pastrecommend'
      // if(i !== 0) custom = 'pastrecommend'
      const pastrecommendRes = adaptResponse(o, state, custom)
      dispatch(addQuestion(pastrecommendRes))
      await dispatch(addTalk({
        id: 'pastrecommend' + 0,
        type: 'question',
        data: pastrecommendRes
      }, TALK_DELAY))
      // if (i === 0) {
        scrollTargetTop(getTalkClass(o.form_id), state)
      // }
      talkBegined(dispatch)
    })()
  // }
}

export const talkResultOtherProc = async (id, options = {}, state, dispatch, custom:string = '') => {
  dispatch(setTalkStart(true))
  const mergeOptions:any = Object.assign({}, {
    name: 'question',
    form_id: id,
    form_type: (state.result.response && state.result.response.question_type) || '',
    question_process_id: (state.result.response && state.result.response.question_process_id) || ''
  }, options)
  const response = await dispatch(Ajax(mergeOptions))
  if (!response) { return }

  dispatch(setResponse(response))
  const brand_array = response.brand_array
  // console.log(response)
  for (let i = 0; i < brand_array.length; i++) {
    ;(async () => {
      const arr = brand_array[i]
      const q_array = (i === (brand_array.length - 1)) ? response.question_array : []
      const o = Object.assign({}, response)
      // MEMO:lastまで空に上書き
      o.form_id = o.id = custom + i
      o.question_array = q_array
      o.brand_array = arr
      const resultotherRes = adaptResponse(o, state, custom)
      // MEMO: GTM 追加？仕様のためNumberフリ
      resultotherRes.data_id = String(i + 1)
      dispatch(addQuestion(resultotherRes))
      await dispatch(addTalk({
        id: response.form_id,
        type: 'question',
        data: resultotherRes
      }, TALK_DELAY))

      // NOTE: 冬タイヤへのリンクを表示するためのフラグ
      if (brand_array.length >= i + 1) {
        dispatch(setQuestionnaireEnded(true))
      }
    })()
  }
  // dispatch(setQuestionnaireEnded(true))
}

// MEMO: from btn_result_action
export const talkCustomProc = async (id, res, state, dispatch, custom:string = '') => {
  dispatch(setTalkStart(true))

  const response = Object.assign({}, res)
  response.form_id = 'resultq'
  const formatResponse = adaptResponse(response, state, custom)
  // NOTE: 逐次レスポンス内容を置き換え
  // 回答送信時に一つ前のform_idを取得できるように
  // dispatch(setResponse(response))
  dispatch(addQuestion(formatResponse))

  ;(async () => {
    await dispatch(addTalk({
      // id: formatResponse.id,
      id: response.form_id,
      type: 'question',
      data: formatResponse
    }, TALK_DELAY))
  })()
}

export const isStartID = (id) => {
  return (id === 'btn_start' || id === 'btn_restart' || id === 'btn_result_action')
}

export const talkProc = async (id, options = {}, state, dispatch, custom:string = '') => {
  dispatch(setTalkStart(true))

  const mergeOptions:any = Object.assign({}, {
    name: 'question',
    form_id: id,
    form_type: (state.result.response && state.result.response.question_type) || '',
    question_process_id: (state.result.response && state.result.response.question_process_id) || ''
  }, options)

  const response = await dispatch(Ajax(mergeOptions))
  if (!response) { return }
  dispatch(setResponse(response))

  // NOTE: set storage > clientname
  if (!getClientName(state) && response.client_name) {
    dispatch(setClientname({
      client_name: response.client_name
    }))
  }

  const formatResponse = adaptResponse(response, state, custom)
  // NOTE: 逐次レスポンス内容を置き換え
  // 回答送信時に一つ前のform_idを取得できるように
  dispatch(addQuestion(formatResponse))

  ;(async () => {
    let iterator = 0
    if (response.display_string) {
      for await (const text of response.display_string) {
        await talkMessage({
          iterator,
          id,
          text
        }, state, dispatch)
        iterator++
      }
    }

    if (response.form_id) {
      await dispatch(addTalk({
        id: response.form_id,
        type: 'question',
        data: formatResponse
      }, TALK_DELAY))

      if (!response.display_string || !response.display_string.length) {
        const scrollID = response.form_id + getStructureID(response.form_id, state)
        scrollTargetTop(getTalkClass(scrollID), state)
      }

      if (isStartID(id)) {
        talkBegined(dispatch)
      }
    }
  })()
}

export const talkAnswer = async (id, state, dispatch) => {}

export const talkReset = async (state, dispatch) => {
  await dispatch(clearTalk(TALK_DELAY))

  const questionKeys = Object.keys(state.questions)
  for (const key of questionKeys) {
    dispatch(clearAnswers({
      id: key
    }))
  }

  dispatch(setTalkStart(false))
  dispatch(setPrevResultStart(false))
  dispatch(setShowRestart(false))
  dispatch(setQuestionnaireEnded(false))
}

export const talkRestart = async (state, dispatch, formID = 'btn_restart', options = {}) => {
  dispatch(openModal({
    type: 'restart',
    options: {
      callback: async () => {
        await talkReset(state, dispatch)
        await talkProc(formID, options, state, dispatch)
      }
    }
  }))
}

export const openQuestionnaireRequest = async (state, dispatch, options?) => {
  if (!state.status.isQuestionnaireRequest) { return }
  // NOTE: EC連携の流入はアンケートを表示しない
  // if (state.status.referrerEC) { return } // NOTE: 値取れない
  if (fromEC(state)) { return }

  let isOpenModal = true
  // NOTE: topの場合のみcookie check
  if (options.use === 'top') {
    if (!isTopQuestionnaireRequestCookie(state)) {
      isOpenModal = false
    }
  }
  if (!isOpenModal) { return }
  dispatch(openModal({
    type: 'questionnairerequest',
    options: {
      // NOTE: 使用箇所
      use: options.use,
      // NOTE: コピー用id
      resultID: getResultID(state)
      // callback: async () => {}
    }
  }))
}

// TODO: SHOP アンケートと同時はないはずだが、万が一同時になったら？
export const openShopCampaign = async (state, dispatch, options?) => {
  if (!state.status.isShopCampaign) { return }

  let isOpenModal = false

  if (fromShopCampaign(state)) {
    isOpenModal = true
  }
  if (!isOpenModal) { return }

  dispatch(openModal({
    type: 'shopcampaign'
  }))
}
